module.exports = __webpack_public_path__ + "assets/img/duix.5a6b62ef.png";